import { render } from "./ExamCode.vue?vue&type=template&id=fc90c3a2&scoped=true"
import script from "./ExamCode.vue?vue&type=script&lang=js"
export * from "./ExamCode.vue?vue&type=script&lang=js"

import "./ExamCode.vue?vue&type=style&index=0&id=fc90c3a2&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc90c3a2"]])

export default __exports__